import { createBrowserHistory } from 'history';
import { PROJECT_BASENAME } from 'constants/env';

export default createBrowserHistory({ basename: PROJECT_BASENAME });
